import { breakpoint } from "@porsche-design-system/components-react/emotion"
import { useMediaQuery } from "./useMediaQuery"

type Breakpoint = keyof typeof breakpoint

interface MatchMediaWidthProps {
	max?: Breakpoint
	min?: Breakpoint
}

export const useMediaQueryWidth = ({ max, min }: MatchMediaWidthProps) => {
	const conditions: string[] = []

	if (min !== undefined) {
		conditions.push(`(min-width: ${breakpoint[min]}px)`)
	}

	if (max !== undefined) {
		conditions.push(`(max-width: ${breakpoint[max]}px)`)
	}

	return useMediaQuery(conditions.join(" and "))
}
